/**
 * Línea de aviso de IA del cuadro de conversación (GEN-PX-005, spec §3.4).
 *
 * Obligación de la capa 6B §6B.8: se ve en toda zona y desde el primer turno, y
 * ni un perfil ni la configuración del tenant la quitan. Por eso este componente
 * no tiene props de ocultar, ni botón de cerrar, ni estado persistido, y nunca
 * devuelve null. Lo monta CuadroConversacion, así que no hay cuadro sin aviso.
 */
import { useState, useEffect } from 'react'
import { Info } from 'lucide-react'
import { Tooltip } from './ui.jsx'
import { textoLinea, textoLegal, textoAgente } from '../lib/avisoIA.js'

export default function AvisoIA({ id, nombre, destinatario, cargo, complemento = '' }) {
  const [abierto, setAbierto] = useState(false)
  useEffect(() => {
    if (!abierto) return undefined
    const alTeclear = (e) => { if (e.key === 'Escape') setAbierto(false) }
    document.addEventListener('keydown', alTeclear)
    return () => document.removeEventListener('keydown', alTeclear)
  }, [abierto])
  const agente = textoAgente(destinatario, cargo)
  return (
    <div className="dk-aviso">
      <Tooltip
        clase="dk-tooltip--texto"
        abierto={abierto}
        texto={abierto ? textoLegal(nombre, cargo) : ''}
      >
        <button
          type="button"
          className="dk-aviso__info"
          aria-label="Texto legal completo del aviso de IA"
          title="Ver el texto legal completo"
          aria-expanded={abierto}
          onClick={() => setAbierto(a => !a)}
          onBlur={() => setAbierto(false)}
        >
          <Info size={14} strokeWidth={1.8} aria-hidden="true" />
        </button>
      </Tooltip>
      <p className="dk-aviso__texto" id={id}>{textoLinea(nombre, cargo)}{complemento ? ` ${complemento}` : ''}</p>
      {agente && <span className="dk-aviso__agente">{agente}</span>}
    </div>
  )
}
